<template>
  <span>
    <span :style="intStyle">{{ prePrice }}</span>
    <span :style="decStyle">{{ sufPrice }}</span>
  </span>
</template>

<script>
import { computed } from 'vue'
import { transPxToRem } from '@/utils'
export default {
  props: {
    intStyle: {
      type: Object,
      default: () => ({
        fontSize: transPxToRem(16)
      })
    },
    decStyle: {
      type: Object,
      default: () => ({
        fontSize: transPxToRem(12)
      })
    },
    price: {
      type: [String, Number],
      default: 0
    }
  },
  setup(props) {
    const priceStrArr = computed(() => props.price.toString().trim().split('.'))
    const prePrice = computed(() => priceStrArr.value[0])
    const sufPrice = computed(() => (priceStrArr.value[1] ? '.' + priceStrArr.value[1] : '.00'))
    return {
      prePrice,
      sufPrice
    }
  }
}
</script>
